const CoverTitleFontSize = {
  GOTHAM_SMALL: 'gotham-small',
  GOTHAM_MEDIUM: 'gotham-medium',
  GOTHAM_LARGE: 'gotham-large',
  KAUFMANN_SMALL: 'kaufmann-small',
  KAUFMANN_MEDIUM: 'kaufmann-medium',
  KAUFMANN_LARGE: 'kaufmann-large',
  properties: {
    'gotham-small': {
      key: 'gotham-small',
      value: '24px',
    },
    'gotham-medium': {
      key: 'gotham-medium',
      value: '32px',
    },
    'gotham-large': {
      key: 'gotham-large',
      value: '47px',
    },
    'kaufmann-small': {
      key: 'kaufmann-small',
      value: '32px',
    },
    'kaufmann-medium': {
      key: 'kaufmann-medium',
      value: '40px',
    },
    'kaufmann-large': {
      key: 'kaufmann-large',
      value: '72px',
    },
  },
};

module.exports = CoverTitleFontSize;
